// console.log('url', process.env.VUE_APP_BASE_API)
const baseUrl = process.env.VUE_APP_BASE_API;
export const basicComponents = [
  {
    type: 'input',
    icon: 'icon-input',
    name: '单行文本',
    options: {
      width: '100%',
      otherClass: '',
      defaultValue: '',
      required: false,
      dataType: 'string',
      pattern: '',
      placeholder: '',
      disabled: false,
      isFix: false
    }
  },
  {
    type: 'textarea',
    icon: 'icon-diy-com-textarea',
    name: '多行文本',
    options: {
      width: '100%',
      otherClass: '',
      defaultValue: '',
      required: false,
      disabled: false,
      pattern: '',
      placeholder: '',
      isFix: false
    }
  },
  {
    type: 'number',
    icon: 'icon-number',
    name: '计数器',
    options: {
      isTotal: false,
      otherClass: '',
      fuMal: '',
      fuMalkey: [],
      width: '',
      required: false,
      defaultValue: 0,
      min: '',
      max: '',
      step: 1,
      disabled: false,
      controlsPosition: '',
      isFix: false
    }
  },
  {
    type: 'radio',
    icon: 'icon-radio-active',
    name: '单选框组',
    options: {
      inline: true,
      defaultValue: '',
      otherClass: '',
      showLabel: false,
      options: [
        {
          value: 'Option 1',
          label: '选项 1'
        },
        {
          value: 'Option 2',
          label: '选项 2'
        },
        {
          value: 'Option 3',
          label: '选项 3'
        }
      ],
      required: false,
      width: '',
      remote: false,
      remoteOptions: [],
      props: {
        value: 'value',
        label: 'label'
      },
      remoteFunc: '',
      disabled: false,
      isFix: false
    }
  },
  {
    type: 'checkbox',
    icon: 'icon-check-box',
    name: '多选框组',
    options: {
      inline: true,
      otherClass: '',
      defaultValue: [],
      showLabel: false,
      options: [
        {
          value: 'Option 1'
        },
        {
          value: 'Option 2'
        },
        {
          value: 'Option 3'
        }
      ],
      required: false,
      width: '',
      remote: false,
      remoteOptions: [],
      props: {
        value: 'value',
        label: 'label'
      },
      remoteFunc: '',
      disabled: false,
      isFix: false
    }
  },
  {
    type: 'time',
    icon: 'icon-time',
    name: '时间选择器',
    options: {
      defaultValue: '21:19:56',
      otherClass: '',
      readonly: false,
      disabled: false,
      editable: true,
      clearable: true,
      placeholder: '',
      startPlaceholder: '',
      endPlaceholder: '',
      isRange: false,
      arrowControl: true,
      format: 'HH:mm:ss',
      required: false,
      width: '',
      isFix: false
    }
  },
  {
    type: 'date',
    icon: 'icon-date',
    name: '日期选择器',
    options: {
      defaultValue: '',
      otherClass: '',
      readonly: false,
      disabled: false,
      editable: true,
      clearable: true,
      placeholder: '',
      startPlaceholder: '',
      endPlaceholder: '',
      type: 'date',
      format: 'yyyy-MM-dd',
      timestamp: false,
      required: false,
      width: '',
      isFix: false
    }
  },
  {
    type: 'text',
    icon: 'icon-wenzishezhi-',
    name: '文字',
    options: {
      defaultValue: 'This is a text',
      otherClass: '',
      customClass: '',
      isFix: false
    }
  },
  {
    type: 'imgupload',
    icon: 'icon-tupian',
    name: '图片/文件',
    options: {
      defaultValue: [],
      otherClass: '',
      required: false,
      size: {
        width: 100,
        height: 100
      },
      width: '',
      tokenFunc: 'funcGetToken',
      token: '',
      disabled: false,
      length: 8,
      multiple: false,
      isQiniu: false,
      isDelete: false,
      min: 0,
      isEdit: false,
      action: `${baseUrl}/Files/Upload`,
      isFix: false
    }
  },
  {
    type: 'formimgupload',
    icon: 'icon-tupian',
    name: '图片/文件',
    options: {
      defaultValue: '',
      otherClass: '',
      required: false,
      size: {
        width: 100,
        height: 100
      },
      width: '',
      tokenFunc: 'funcGetToken',
      token: '',
      disabled: false,
      length: 8,
      multiple: false,
      isQiniu: false,
      isDelete: false,
      min: 0,
      isEdit: false,
      action: `${baseUrl}/Files/Upload`,
      isFix: false
    }
  },
  {
    type: 'select',
    icon: 'icon-select',
    name: '下拉选择框',
    options: {
      defaultValue: '',
      otherClass: '',
      multiple: false,
      disabled: false,
      clearable: false,
      placeholder: '',
      required: false,
      showLabel: false,
      width: '',
      options: [
        {
          value: 'Option 1'
        },
        {
          value: 'Option 2'
        }, {
          value: 'Option 3'
        }
      ],
      remote: false,
      filterable: false,
      remoteOptions: [],
      props: {
        value: 'value',
        label: 'label'
      },
      remoteFunc: '',
      isFix: false
    }
  },
  {
    type: 'grid',
    icon: 'icon-grid-',
    name: '栅格布局',
    columns: [
      {
        span: 12,
        list: []
      },
      {
        span: 12,
        list: []
      }
    ],
    options: {
      gutter: 0,
      justify: 'start',
      otherClass: '',
      align: 'top'
    }
  },
  {
    type: 'collapse',
    icon: 'icon-collapse-',
    name: '折叠面板',
    columns: [
      {
        title: '折叠面板1',
        name: '0',
        disabled: false,
        list: []
      }
    ],
    options: {
      accordion: false,
      isFix: false
    }
  },

  {
    type: 'selecType',
    icon: 'icon-select',
    name: '自定义下拉框',
    options: {
      defaultValue: '',
      otherClass: '',
      multiple: false,
      isEdit: true,
      disabled: false,
      clearable: false,
      placeholder: '',
      required: false,
      showLabel: false,
      typeId: '',
      width: '',
      options: [
        {
          value: 'Option 1'
        },
        {
          value: 'Option 2'
        }, {
          value: 'Option 3'
        }
      ],
      remote: false,
      filterable: false,
      remoteOptions: [],
      props: {
        value: 'value',
        label: 'label'
      },
      remoteFunc: '',
      isFix: false
    }
  },
  {
    type: 'selecTypeByApi',
    icon: 'icon-select',
    name: '根据api数据自定义下拉框',
    options: {
      defaultValue: '',
      otherquery: [{
        querykey: '',
        modelkey: ''
      }],
      relatedName: '',
      otherClass: '',
      idKey: 'id',
      nameKey: 'name',
      apiName: '',
      getDataMethod: 'load',
      multiple: false,
      disabled: false,
      clearable: false,
      placeholder: '',
      required: false,
      showLabel: false,
      width: '',
      remote: false,
      filterable: false,
      remoteOptions: [],
      remoteFunc: '',
      isFix: false
    }
  },
  {
    type: 'autoNew',
    icon: 'icon-autonew',
    name: '选择',
    options: {
      width: '100%',
      otherClass: '',
      defaultValue: '',
      placeholder: '',
      disabled: false,
      required: false,
      remoteFunc: '',
      relatedName: '',
      idKey: 'id',
      nameKey: 'name',
      apiName: '',
      getDataMethod: 'load',
      returnKey: [{
        querykey: '', // 查询出来取值的字段
        modelkey: ''// 查询出来的值要赋值的字段
      }],
      otherquery: [{
        querykey: '', // 查询组件的字段，比如现在是联系人，那么这个地方是联系人的客户字段 用来查询条件
        modelkey: ''// 在当前这个页面中取值的字段，比如现在用的这个页面的联系人字段 用来查询条件赋值
      }],
      isFix: false
    },
    key: '',
    model: '',
    rules: []
  },

  {
    type: 'color',
    icon: 'icon-color',
    options: {
      defaultValue: '',
      otherClass: '',
      disabled: false,
      showAlpha: false,
      required: false,
      isFix: false
    }
  },
  {
    type: 'switch',
    icon: 'icon-switch',
    options: {
      defaultValue: false,
      otherClass: '',
      customizeopen: 'true',
      customizeclose: 'false',
      customizeType: 'string',
      required: false,
      disabled: false,
      isFix: false
    }
  },
  {
    type: 'slider',
    icon: 'icon-slider',
    options: {
      defaultValue: 0,
      otherClass: '',
      disabled: false,
      required: false,
      min: 0,
      max: 100,
      step: 1,
      showInput: false,
      range: false,
      width: '',
      isFix: false
    }
  },
  {
    type: 'rate',
    icon: 'icon-pingfen1',
    options: {
      defaultValue: null,
      max: 5,
      otherClass: '',
      disabled: false,
      allowHalf: false,
      required: false,
      isFix: false
    }
  },
  {
    type: 'cascader',
    icon: 'icon-jilianxuanze',
    options: {
      defaultValue: [],
      otherClass: '',
      width: '',
      placeholder: '',
      disabled: false,
      clearable: false,
      remote: true,
      remoteOptions: [],
      props: {
        value: 'value',
        label: 'label',
        children: 'children'
      },
      remoteFunc: '',
      isFix: false
    }
  },
  {
    type: 'table',
    icon: 'icon-grid-1',
    name: '子表单',
    list: [],
    options: {
      width: '200px',
      otherClass: '',
      defaultValue: [],
      required: false,
      dataType: 'string',
      pattern: '',
      placeholder: '',
      customClass: '',
      disabled: false,
      btnadd: true,
      btndel: true,
      labelWidth: 100,
      isLabelWidth: false,
      hidden: false,
      dataBind: true,
      showPassword: false,
      remoteFunc: '',
      remoteOption: '',
      tableColumn: true,
      tableHeight: ''
    }
  },
  {
    type: 'blank',
    icon: 'icon-zidingyishuju',
    options: {
      defaultType: 'String',
      otherClass: '',
      isTitle: true,
      isFix: false
    }
  }
];

export const advanceComponents = [
  // {
  //   type: 'blank',
  //   icon: 'icon-zidingyishuju',
  //   options: {
  //     defaultType: 'String'
  //   }
  // },
  // {
  //   type: 'editor',
  //   icon: 'icon-fuwenbenkuang',
  //   options: {
  //     defaultValue: '',
  //     width: ''
  //   }
  // },
  // {
  //   type: 'cascader',
  //   icon: 'icon-jilianxuanze',
  //   options: {
  //     defaultValue: [],
  //     width: '',
  //     placeholder: '',
  //     disabled: false,
  //     clearable: false,
  //     remote: true,
  //     remoteOptions: [],
  //     props: {
  //       value: 'value',
  //       label: 'label',
  //       children: 'children'
  //     },
  //     remoteFunc: ''
  //   }
  // }
];

export const layoutComponents = [
  {
    type: 'grid',
    icon: 'icon-grid-',
    name: '栅格布局',
    columns: [
      {
        span: 12,
        list: []
      },
      {
        span: 12,
        list: []
      }
    ],
    options: {
      gutter: 0,
      otherClass: '',
      justify: 'start',
      align: 'top'
    }
  }
];
